import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  table {
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    td {
      text-align: center;
      margin: 0;
      padding: 0.5rem;

      :last-child {
        border-right: 0;
      }
    }
  }
`;
